module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_24-5e19758748b997f6477ad7956ab64fe1.png";